// extracted by mini-css-extract-plugin
export default {"logo":"L-29E2eV528DXZg5A8BUb","breathing":"urbt9onNS42Xiilg2mJnY"};